import { defineComponent } from "vue";
import { SvgIcon } from "@/components/index";
import QRCodeScanSvg from "@/assets/images/svg/qr-code-scan.svg";
import ModalModule from "@/store/modules/modal";
import { ModalStatus } from "@/constants/modal";
import { useI18n } from "vue-i18n";
export default defineComponent({
  name: "NavbarScanQrCode",
  components: {
    SvgIcon: SvgIcon
  },
  setup: function setup() {
    var _useI18n = useI18n({}),
        t = _useI18n.t;

    var iconStyle = "filter: contrast(170%) invert(100%);";
    return {
      t: t,
      QRCodeScanSvg: QRCodeScanSvg,
      iconStyle: iconStyle
    };
  },
  methods: {
    showScanQRCodeModal: function showScanQRCodeModal() {
      ModalModule.setStatus(ModalStatus.ScanQrCode);
    }
  }
});